import React from "react";
import { makeStyles } from "@material-ui/core";
import MarkdownWrapper from "../MarkdownWrapper";
import { splitMentions } from "./mentions";

// Texto de mensagem com as menções ("@<id>") trocadas por "@Nome", na cor de menção do
// WhatsApp Web. `resolve(dígitos)` devolve { label, title } ou null quando não é menção.
const useStyles = makeStyles((theme) => ({
  mention: {
    color: theme.palette.type === "dark" ? "#53bdeb" : "#027eb5",
    fontWeight: 500,
    whiteSpace: "nowrap",
  },
}));

const MentionText = ({ text, resolve, plain = false }) => {
  const classes = useStyles();
  const source = text == null ? "" : String(text);
  const renderMarkdown = (value) => (plain || !value ? value : <MarkdownWrapper>{value}</MarkdownWrapper>);
  // Espaços e quebras de linha coladas na menção ficam fora do markdown, que os engoliria
  // ("*Fulano:*\n@Nome" perdia a quebra de linha).
  const renderPlain = (value) => {
    if (plain) return value;
    const match = /^(\s*)([\s\S]*?)(\s*)$/.exec(value);
    return (
      <>
        {match[1]}
        {renderMarkdown(match[2])}
        {match[3]}
      </>
    );
  };

  if (!resolve || source.indexOf("@") === -1) return renderMarkdown(source);

  const pieces = [];
  let buffer = "";
  let found = false;
  splitMentions(source).forEach((part) => {
    if (part.text !== undefined) {
      buffer += part.text;
      return;
    }
    const mention = resolve(part.mention);
    if (!mention) {
      buffer += `@${part.mention}`;
      return;
    }
    found = true;
    if (buffer) pieces.push({ text: buffer });
    buffer = "";
    pieces.push({ mention });
  });
  if (buffer) pieces.push({ text: buffer });
  if (!found) return renderMarkdown(source);

  return (
    <>
      {pieces.map((piece, i) =>
        piece.mention ? (
          <span key={i} className={classes.mention} title={piece.mention.title} data-mention="true">
            {piece.mention.label}
          </span>
        ) : (
          <React.Fragment key={i}>{renderPlain(piece.text)}</React.Fragment>
        )
      )}
    </>
  );
};

export default MentionText;
